.ai{flex:1;}